<template>
    <header class="d-flex mb-5">
        <h1 class="d-flex align-self-center flex-grow-1 justify-content-center font-righteous">DTM Cafe</h1>
    </header>
</template>

<script>
    export default {
        name: "Header"
    }
</script>

<style scoped>
    header {
        background: url("../assets/img/bg_kv.jpg") no-repeat center;
        background-size: cover;
        height: 30vh;
    }

    header h1 {
        color: #fff;
        font-size: 5rem;
        background-color: rgba(0, 0, 0, 0.5);
        padding: 1rem 0;
        width: 100%;
    }
</style>
